export const SETTING_TYPE_TRADE = 1
export const SETTING_TYPE_SYSTEM = 2
export const SETTING_TYPE_ALL = 'ALL'


export const FOOTER = {
    DAILYRESULT: 1,
    MARGINSUM: 5,
}